import Business from './index.vue';
const routes = [
  {
    path: '/business',
    name: 'Business',
    component: Business,
    children: [
      {
        path: 'details',
        meta: {
          requiresAuth: true,
          preventBrowserBack: true
        },
        name: 'BusinessDetailsScreen',
        component: () => import('./views/BusinessDetails.vue')
      },
      {
        path: 'editAddress',
        meta: {
          requiresAuth: true,
          preventBrowserBack: true
        },
        name: 'BusinessEditAddressScreen',
        component: () => import('./views/EditBusinessAddress.vue')
      }
    ]
  }
];

export default routes;
